import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DialogComponent } from '@prekog/common-ui';
import { AddDiscountPriceDialogResult } from './adddiscountpricedialogresult';

@Component({
    selector: 'app-adddiscountpricedialog',
    templateUrl: './adddiscountpricedialog.component.html',
    styleUrls: ['./adddiscountpricedialog.component.scss'],
    standalone: true,
    imports: [MatIconModule, MatDialogModule, ReactiveFormsModule]
})
export class AddDiscountpriceDialogComponent extends DialogComponent {
    discountPriceForm?: FormGroup;

    constructor(
        private _fb: FormBuilder
    ) {
        super();
        this.createPPackageForm();
    }

    createPPackageForm() {
        this.discountPriceForm = this._fb.group({
            discountPrice: ['', [Validators.required]]
        });
    }

    addDiscountPrice() {
        const addDiscountPriceDialogResult: AddDiscountPriceDialogResult = {
            discountPrice: this.discountPriceForm?.controls['discountPrice'].value as number | undefined
        }
        this.accept(addDiscountPriceDialogResult);
    }
}
